import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { FormFor } from 'react-rails-form-helpers';
import PropTypes from 'prop-types';
import {
  Container, makeStyles, Paper,
} from '@material-ui/core';
import FloatingLabelInput from '../../components/FloatingLabelInput';
import UtilsService from '../../../services/UtilsService';

const useStyles = makeStyles((theme) => ({
  paperBox: {
    maxWidth: 600,
    marginTop: theme.spacing(3),
    padding: theme.spacing(9),
    boxShadow: theme.shadows[3],
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100vw',
    height: '100vh',
  },
  submitBtn: {
    marginTop: 20,
  },
}));

const ResetPasswords = (props) => {
  const { routes, userId } = props;
  const classes = useStyles();
  const initialState = {
    password: '',
    confirmation: '',
  };

  const [state, setState] = useState(initialState);

  const fields = [
    {
      id: 'password',
      label: 'Senha',
      type: 'password',
      field: 'password',
      validations: [
        (v) => !!v || 'Senha é obrigatória',
      ],
      autoFocus: false,
      required: true,
    },
    {
      id: 'confirmation',
      label: 'Confirmação da senha',
      type: 'password',
      field: 'confirmation',
      validations: [
        (v) => !!v || 'Confirmação da senha é obrigatória',
        (v) => v === state.password || 'As senhas não são iguais',
      ],
      autoFocus: false,
      required: true,
    },
  ];

  const handleChange = (id, value) => {
    setState({
      ...state,
      [id]: value,
    });
  };

  const validInputs = () => UtilsService.validateState(fields, state);

  const getUrlForm = () => {
    const path = routes.resetPasswordChangePasswordPath;
    return path.replace(':id', userId);
  };

  return (
    <>
      <Container component="main" className={classes.container}>
        <div>
          <Typography component="h1" variant="h5" align="center">
            Recuperação de senha
          </Typography>
          <Paper className={classes.paperBox}>
            <FormFor
              method="post"
              url={getUrlForm()}
              className={classes.form}
            >
              <Grid container spacing={3}>
                {fields.map(({
                  id, label, type, field, validations, required, autoFocus,
                }) => (
                  <FloatingLabelInput
                    key={field}
                    id={id}
                    label={label}
                    type={type}
                    value={state[id]}
                    onChange={handleChange}
                    validationRules={validations}
                    name={field}
                    required={required}
                    autoFocus={autoFocus}
                  />
                ))}
                <Grid item xs={12}>
                  <Button
                    className={classes.submitBtn}
                    disabled={!validInputs()}
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                  >
                    Confirmar
                  </Button>
                </Grid>
              </Grid>
            </FormFor>
          </Paper>
        </div>
      </Container>
    </>
  );
};

ResetPasswords.propTypes = {
  routes: PropTypes.objectOf(PropTypes.string),
  userId: PropTypes.string,
};

export default ResetPasswords;
